export function isWhiteLabelProject() {
	const names = process.env.REACT_APP_PROJECT_NAME;

	const project = {
		keepa: false,
		'tantak': true,
		entekhab: true,
		sabalend: true,
		'refahyar': true,
		fara: true,
		hamtaland: true,
		rayansaipa: true,
		ghestane: true,
		demo: true,
		tisa: true,
		saana: true,
		shopp: true,
		arbaeen: true,
		danesh: true,
		karma: true,
		hastesh: true,
		armanpay: true,
		lendavid: true,
		'flytoday': true,
		calko: true,
		can: true,
	};

	return project[names] || false;
}
